import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import {
  Security as SecurityIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import "./PermissionManagement.css";
import { AppTab, AppTabPanel } from "components/common/tabs";

const PermissionManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [
    { label: "Tổng quan phân quyền", icon: <SecurityIcon />, value: 0 },
    { label: "Phân quyền vai trò", icon: <AssignmentIcon />, value: 1 },
    { label: "Gán vai trò cho người dùng", icon: <GroupIcon />, value: 2 },
    { label: "Phân quyền người dùng", icon: <PersonIcon />, value: 3 },
  ];

  // Xác định tab hiện tại dựa trên URL
  const getCurrentTab = () => {
    const path = location.pathname;
    if (path.includes("/overview")) return 0;
    if (path.includes("/role-permissions")) return 1;
    if (path.includes("/user-roles")) return 2;
    if (path.includes("/user-permissions")) return 3;
    return 0; // Mặc định về tab đầu tiên
  };

  const [tabValue, setTabValue] = useState(getCurrentTab());

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // Điều hướng đến route tương ứng
    const basePath = location.pathname.startsWith("/systems/permissions")
      ? "/systems/permissions"
      : "/admin/permissions";
    const routes = [
      `${basePath}/overview`,
      `${basePath}/role-permissions`,
      `${basePath}/user-roles`,
      `${basePath}/user-permissions`,
    ];

    navigate(routes[newValue]);
  };

  // Cập nhật tab khi URL thay đổi (ví dụ từ back/forward button)
  React.useEffect(() => {
    setTabValue(getCurrentTab());
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box className="permission-management">
      <Paper elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <AppTab
            value={tabValue}
            onChange={handleTabChange}
            tabs={tabs}
          />
        </Box>

        <Box sx={{ p: 0 }}>
          {/* Outlet sẽ render component con tương ứng */}
          <Outlet />
        </Box>
      </Paper>
    </Box>
  );
};

export default PermissionManagement;
